import { useContext } from "react";

import { TenantContext } from "@nens/ranalib";

import { useProfileImageQuery } from "../../queries/query-profile-picture";

import { AnyUser } from "./types/any-user";

export function useProfile(user: "self" | AnyUser | undefined) {
  const authInfo = useContext(TenantContext);
  const selfUser = !authInfo.isPublic ? authInfo.user : undefined;
  const appliedUser = user === "self" ? selfUser : user;

  const isApiKeyUser = appliedUser && "apiKey" in appliedUser && appliedUser.apiKey;
  const isDeleted = appliedUser && "deleted" in appliedUser && !!appliedUser.deleted;

  const { data: userImage } = useProfileImageQuery(!isApiKeyUser ? appliedUser?.id : undefined);

  const userInitials = appliedUser && appliedUser.givenName[0] + appliedUser.familyName[0];

  return { userInitials, userImage, appliedUser, isDeleted, isApiKeyUser };
}
